import { Button as AntButton, ButtonProps } from 'antd'
import { EColorButton } from 'enums'
import { ReactNode } from 'react'
import styled from 'styled-components'

const StyledButton = styled(AntButton)`
  display: inline-flex;
  align-items: center;
  &.blue {
    background: var(--color-blue-106);
    color: white;
    border-color: var(--color-blue-106);
    &.btn-outline {
      background: white;
      color: var(--color-blue-100);
      &:hover {
        background: var(--color-blue-108);
        color: var(--color-blue-106);
      }
    }
  }
  &.gray {
    background: var(--color-gray-105);
    color: white;
    border-color: var(--color-gray-105);
    &.btn-outline {
      background: white;
      color: var(--color-gray-105);
      &:hover {
        background: var(--color-gray-105);
        color: var(--color-gray-105);
      }
    }
  }
  &.green {
    background: var(--color-primary-108);
    color: white;
    border-color: var(--color-primary-108);
    &.btn-outline {
      background: white;
      color: var(--color-primary-108);
      &:hover {
        background: var(--color-primary-108);
        color: white;
      }
    }
  }
  &.red {
    background: var(--color-red-107);
    color: white;
    border-color: var(--color-red-107);
    &.btn-outline {
      background: white;
      color: var(--color-red-107);
      &:hover {
        background: var(--color-red-107);
        color: white;
      }
    }
  }
  &.blue-trace {
    background: var(--color-blue-102);
    color: var(--color-blue-108);
    border-color: var(--color-blue-102);
    &.btn-outline {
      background: white;
      color: var(--color-blue-108);
      &:hover {
        background: var(--color-blue-102);
        color: var(--color-blue-108);
      }
    }
  }
  &.cyan-trace {
    background: var(--color-cyan-102);
    color: var(--color-cyan-106);
    border-color: var(--color-cyan-102);
    &.btn-outline {
      background: white;
      color: var(--color-cyan-106);
      &:hover {
        background: var(--color-cyan-102);
        color: var(--color-cyan-106);
      }
    }
  }
  &.green-trace {
    background: var(--color-primary-102);
    color: var(--color-primary-108);
    border-color: var(--color-primary-102);
    &.btn-outline {
      background: white;
      color: var(--color-primary-108);
      &:hover {
        background: var(--color-primary-102);
        color: var(--color-primary-108);
      }
    }
  }
  &.red-trace {
    background: var(--color-red-102);
    color: var(--color-red-107);
    border-color: var(--color-red-102);
    &.btn-outline {
      background: white;
      color: var(--color-red-107);
      &:hover {
        background: var(--color-red-102);
        color: var(--color-red-107);
      }
    }
  }
  &.yellow-trace {
    background: var(--color-yellow-102);
    color: var(--color-yellow-107);
    border-color: var(--color-yellow-102);
    &.btn-outline {
      background: white;
      color: var(--color-yellow-107);
      &:hover {
        background: var(--color-yellow-102);
        color: var(--color-yellow-107);
      }
    }
  }
  &.ant-btn {
    padding: 8px 12px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 4px;
    }
  }
  &.ant-btn[disabled],
  &.ant-btn[disabled]:hover,
  &.ant-btn[disabled]:focus,
  &.ant-btn[disabled]:active {
    color: rgba(0, 0, 0, 0.25);
    border-color: #d9d9d9;
    background: #f5f5f5;
  }
  height: 40px;
  display: flex;
  justify-content: center;
  &.full-width {
    width: 100%;
  }
  &.no-background {
    background: white;
    border: none;
    color: var(--color-blue-108);
    cursor: default;
    box-shadow: none;
    span {
      cursor: pointer;
    }
    &::after {
      display: none;
    }
    &.allow-click-outside {
      cursor: pointer;
    }
    &:hover {
      opacity: 0.85;
      border: 1px solid;
    }
  }
`

interface IProps extends ButtonProps {
  children?: ReactNode
  color?:
    | 'blue'
    | 'green'
    | 'yellow'
    | 'red'
    | 'gray'
    | 'blue-trace'
    | 'green-trace'
    | 'red-trace'
    | 'yellow-trace'
    | EColorButton
  btnOutline?: boolean
  className?: string
  fullWidth?: boolean
  noBackground?: boolean
  allowClickOutside?: boolean
}

const Button = (props: IProps) => {
  const {
    children,
    btnOutline,
    className,
    fullWidth,
    noBackground,
    allowClickOutside,
    onClick,
    color = 'blue',
    ...resPros
  } = props
  const handleOnClick = (e: any, clickText?: boolean) => {
    if (!clickText && noBackground && !allowClickOutside) return
    if (onClick) onClick(e)
  }
  const classNameText = `${color} ${
    btnOutline ? 'btn-outline' : ''
  } ${className} ${fullWidth ? 'full-width' : ''} ${
    noBackground ? 'no-background' : ''
  } ${allowClickOutside ? 'allow-click-outside' : ''}`

  return (
    <>
      <StyledButton
        className={classNameText}
        onClick={(e) => handleOnClick(e, false)}
        {...resPros}>
        {noBackground && (
          <span onClick={(e) => handleOnClick(e, true)}> {children}</span>
        )}
        {!noBackground && children}
      </StyledButton>
    </>
  )
}

export default Button
